import NavContact from "./NavContact.component";

import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import logo from "../assets/logo.svg";
import { HiMenu } from "react-icons/hi";
import { CgClose } from "react-icons/cg";
import { BsCaretDownFill } from "react-icons/bs";
import { BsCaretRightFill } from "react-icons/bs";

function NavBar() {
    let asideRef = useRef(null);
    let overlayRef = useRef(null);
    const location = useLocation();

    const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);

    const solutionsRef = useRef(null);
    const servicesRef = useRef(null);
    const aboutRef = useRef(null);

    const toggleSolutions = () => {
        setIsSolutionsOpen(!isSolutionsOpen);
        setIsServicesOpen(false);
        setIsAboutOpen(false);
    };

    const toggleServices = () => {
        setIsServicesOpen(!isServicesOpen);
        setIsSolutionsOpen(false);
        setIsAboutOpen(false);
    };

    const toggleAbout = () => {
        setIsAboutOpen(!isAboutOpen);
        setIsSolutionsOpen(false);
        setIsServicesOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                solutionsRef.current &&
                !solutionsRef.current.contains(event.target) &&
                servicesRef.current &&
                !servicesRef.current.contains(event.target) &&
                aboutRef.current &&
                !aboutRef.current.contains(event.target)
            ) {
                setIsSolutionsOpen(false);
                setIsServicesOpen(false);
                setIsAboutOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const solutionsPaths = [
        "/solutions/sswayamcrm",
        "/solutions/sswayamcrmerp",
        "/solutions/hospital-management",
        "/solutions/image-processing",
        "/solutions/machine-learning",
        "/solutions/offline-tax-management",
        "/solutions/online-tax-management",
        "/solutions/online-exam-management-software",
        "/solutions/online-feedback-survey-tool",
        "/solutions/robotic-uv-sanitizer",
        "/solutions/standard-sswayam-crm",
        "/solutions/school-management",
        "/solutions/verify-me",
    ];

    // Mapping URLs to their respective display titles
    const displayTitles = {
        sswayamcrm: "Sswayam CRM Web Application / Mobile Application",
        sswayamcrmerp: "Sswayam CRM (ERP) for B2C and B2B",
        "hospital-management": "Hospital Management",
        "image-processing": "Image Processing",
        "machine-learning": "Machine Learning",
        "offline-tax-management": "Offline Tax Management",
        "online-tax-management": "Online Tax Management",
        "online-exam-module": "Online Exam Module",
        "online-survey-tool": "Online Survey Tool",
        "robotic-uv-sanitizer": "Robotic UV Sanitizer",
        "standard-sswayam-crm": "Standard Sswayam CRM",
        "school-management": "School Management",
        "verify-me": "Verify Me",
    };
    const isSolutionsActive = solutionsPaths.includes(location.pathname);

    const services = [
        "/services/aws",
        "/services/advanced-analytics",
        "/services/basic-analytics",
        "/services/consulting",
        "/services/data-science",
        "/services/iot-robotics",
        "/services/mobile-application",
        "/services/web-application",
    ];
    const isServicesActive = services.includes(location.pathname);

    const aboutUs = ["/about-our-story", "/board-of-advisory"];
    const isAboutUsActive = aboutUs.includes(location.pathname);
    // const isAboutUs = aboutUs.includes(location.pathname);

    function open() {
        asideRef.current.style.overflow = "visible";
        asideRef.current.style.width = "70%";
        overlayRef.current.style.width = "100%";
    }
    function close() {
        asideRef.current.style.overflow = "hidden";
        asideRef.current.style.width = "0px";
        overlayRef.current.style.width = "0px";
    }

    function Accordion({ title, items, isActive, displayTitlesMap }) {
        const [isOpen, setIsOpen] = useState(false);

        return (
            <div className="flex flex-col items-center">
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    className={`flex items-center cursor-pointer ${
                        isActive ? "text-primary underline font-bold" : "hover:text-primary"
                    }`}
                >
                    {title}
                    <BsCaretRightFill
                        className={`ml-2 transition-transform duration-300 ${
                            isOpen ? "rotate-90" : ""
                        }`}
                    />
                </div>

                {/* Accordion Dropdown */}
                <div
                    className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                        isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                    }`}
                    style={{ maxHeight: isOpen ? "400px" : "0px" }}
                >
                    <div className="flex flex-col items-start py-4 px-4 space-y-2">
                        {items.map((path) => {
                            const pathKey = path.split("/").pop();
                            const displayText =
                                displayTitlesMap && displayTitlesMap[pathKey]
                                    ? displayTitlesMap[pathKey]
                                    : pathKey.replace(/-/g, " ");

                            return (
                                <NavLink
                                    key={path}
                                    to={path}
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-primary underline font-bold"
                                            : "hover:text-primary"
                                    }
                                >
                                    {displayText ? displayText : ""}
                                </NavLink>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    function Aside() {
        return (
            <div>
                {/* ASIDE MAIN SECTION */}
                <div
                    className={`fixed top-0 right-0 bg-white h-full w-0 z-20 shadow-2xl transition-all`}
                    ref={asideRef}
                >
                    {/* CROSS BUTTON CONTAINER */}
                    <div className="flex justify-between items-center h-[calc(80px+16px)] md:h-[calc(100px+16px)] custom-container">
                        <span></span>
                        <span onClick={close}>
                            <CgClose className="text-4xl text-primary active:scale-[0.95]" />
                        </span>
                    </div>

                    {/* Scrollable NavLinks Container */}
                    <div className="overflow-y-auto h-[calc(100vh-96px)] px-4 pb-10 flex flex-col items-center justify-start gap-10 mt-4 font-semibold">
                        <NavLink
                            className={`bg-primary text-white py-2 px-5 rounded shadow press`}
                            to={"/quote"}
                        >
                            Request For Quote
                        </NavLink>

                        <NavLink
                            to="/home"
                            className={({ isActive }) =>
                                isActive ? "text-primary underline font-bold" : "hover:text-primary"
                            }
                        >
                            Home
                        </NavLink>

                        <Accordion title="ABOUT US" items={aboutUs} isActive={isAboutUsActive} />
                        <Accordion
                            title="SOLUTIONS"
                            items={solutionsPaths}
                            isActive={isSolutionsActive}
                            displayTitlesMap={displayTitles}
                        />
                        <Accordion title="SERVICES" items={services} isActive={isServicesActive} />

                        <NavLink
                            to={"/careers"}
                            className={({ isActive }) =>
                                isActive ? "text-primary underline font-bold" : "hover:text-primary"
                            }
                        >
                            Careers
                        </NavLink>
                        <NavLink
                            to={"/contact-us"}
                            className={({ isActive }) =>
                                isActive ? "text-primary underline font-bold" : "hover:text-primary"
                            }
                        >
                            Contact Us
                        </NavLink>
                        <NavLink
                            to={"/blogs"}
                            className={({ isActive }) =>
                                isActive ? "text-primary underline font-bold" : "hover:text-primary"
                            }
                        >
                            Blogs
                        </NavLink>
                    </div>
                </div>

                {/* OVERLAY */}
                <div
                    className={`fixed overflow-hidden top-0 right-0 backdrop-blur-sm h-full w-[0px] z-10`}
                    onClick={close}
                    ref={overlayRef}
                ></div>
            </div>
        );
    }

    return (
        <>
            <section
                className={`whitespace-nowrap h-[10vh] fixed top-0 left-0 w-full bg-white z-50 shadow`}
            >
                {/* ASIDE */}
                <Aside />

                {/* NAVBAR */}
                <div className="flex items-center justify-between py-2 h-[10vh] custom-container">
                    {/* LEFT : LOGO SECTION */}
                    <div className="shrink-0">
                        <NavLink
                            to="/home"
                            className={({ isActive }) =>
                                isActive
                                    ? "press text-primary underline font-bold"
                                    : "press hover:text-primary"
                            }
                        >
                            <img src={logo} className="h-10 lg:h-14" alt="logo" />
                        </NavLink>
                    </div>

                    {/* RIGHT : MENU ICON [ SMALL DEVICE ] */}
                    <div className="lg:hidden" onClick={open}>
                        <HiMenu className="text-4xl text-primary active:scale-[0.95]" />
                    </div>

                    {/* RIGHT :  NAVLINK [ LARGE DEVICE ]  */}
                    <div className="hidden lg:flex m-1 p-1 justify-between items-center font-semibold grow max-w-[1000px] ml-10 capitalize">
                        <NavLink
                            to="/home"
                            className={() =>
                                location.pathname === "/" || location.pathname === "/home"
                                    ? "press text-primary underline font-bold"
                                    : "press hover:text-primary"
                            }
                        >
                            home
                        </NavLink>
                        <div className="relative" ref={aboutRef}>
                            <button
                                onClick={toggleAbout}
                                className={`flex items-center gap-1 m-1 p-1 text-sm lg:text-base ${
                                    isAboutUsActive
                                        ? "text-primary underline font-bold"
                                        : "hover:text-primary hover:underline"
                                }`}
                            >
                                About us
                                {isAboutOpen ? <BsCaretRightFill /> : <BsCaretDownFill />}
                            </button>
                            {isAboutOpen && (
                                <div className="absolute left-0 p-6 mt-2 w-max bg-white shadow-xl z-50">
                                    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                                        {aboutUs.map((path) => (
                                            <li key={path} className="press py-1.5 text-[13px]">
                                                <NavLink
                                                    to={path}
                                                    className={({ isActive }) =>
                                                        isActive
                                                            ? "press text-primary underline font-bold capitalize"
                                                            : "press hover:text-primary hover:underline capitalize"
                                                    }
                                                >
                                                    {path.replace("/", "").replace(/-/g, " ")}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="relative" ref={solutionsRef}>
                            <button
                                onClick={toggleSolutions}
                                className={`flex items-center gap-1 m-1 p-1 text-sm lg:text-base ${
                                    isSolutionsActive
                                        ? "text-primary underline font-bold"
                                        : "hover:text-primary hover:underline"
                                }`}
                            >
                                Solutions
                                {isSolutionsOpen ? <BsCaretRightFill /> : <BsCaretDownFill />}
                            </button>
                            {isSolutionsOpen && (
                                <div className="absolute left-0 p-6 mt-2 w-max bg-white shadow-xl z-50">
                                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                                        {solutionsPaths.map((path) => {
                                            const pathKey = path.replace("/solutions/", "");
                                            return (
                                                <li key={path} className="press py-1.5 text-[13px]">
                                                    <NavLink
                                                        to={path}
                                                        className={({ isActive }) =>
                                                            isActive
                                                                ? "press text-primary underline font-bold capitalize"
                                                                : "press hover:text-primary hover:underline capitalize"
                                                        }
                                                    >
                                                        {displayTitles[pathKey] ||
                                                            pathKey.replace(/-/g, " ")}
                                                    </NavLink>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}
                        </div>

                        {/* Services Dropdown */}
                        <div className="relative" ref={servicesRef}>
                            <button
                                onClick={toggleServices}
                                className={`flex items-center gap-1 m-1 p-1 text-sm lg:text-base ${
                                    isServicesActive
                                        ? "text-primary underline font-bold"
                                        : "hover:text-primary hover:underline"
                                }`}
                            >
                                Services
                                {isServicesOpen ? <BsCaretRightFill /> : <BsCaretDownFill />}
                            </button>
                            {isServicesOpen && (
                                <div className="absolute left-0 p-6 mt-2 w-max bg-white shadow-xl z-50">
                                    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                                        {services.map((path) => (
                                            <li key={path} className="press py-1.5 text-[13px]">
                                                <NavLink
                                                    to={path}
                                                    className={({ isActive }) =>
                                                        isActive
                                                            ? "press text-primary underline font-bold capitalize"
                                                            : "press hover:text-primary hover:underline capitalize"
                                                    }
                                                >
                                                    {path
                                                        .replace("/services/", "")
                                                        .replace(/-/g, " ")}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <NavLink
                            to={"/careers"}
                            className={({ isActive }) =>
                                isActive
                                    ? "press text-primary underline font-bold"
                                    : "press hover:text-primary"
                            }
                        >
                            Careers
                        </NavLink>
                        <NavLink
                            to={"/contact-us"}
                            className={({ isActive }) =>
                                isActive
                                    ? "press text-primary underline font-bold"
                                    : "press hover:text-primary"
                            }
                        >
                            Contact Us
                        </NavLink>
                        <NavLink
                            to={"/blogs"}
                            className={({ isActive }) =>
                                isActive
                                    ? "press text-primary underline font-bold "
                                    : "press hover:text-primary"
                            }
                        >
                            Blogs
                        </NavLink>
                        <NavLink
                            className={`bg-primary text-white py-1 px-5 rounded shadow hover:bg-[#1d5cb5] transition duration-300 ease-in-out`}
                            to={`/quote`}
                        >
                            Request For Quote
                        </NavLink>
                    </div>
                </div>

                <NavContact />
            </section>
        </>
    );
}

export default NavBar;
